module.exports = __webpack_public_path__ + "static/media/web-campaigns.0fa650d4.svg";